import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { switchLocalizedPath } from '@/i18n/routes'
export function LanguageSelector() {
  const { t, i18n } = useTranslation('common')
  const location = useLocation()
  const navigate = useNavigate()
  return <div className="language-selector" role="group" aria-label={t('shell.language')}>
    {(['it', 'en'] as const).map(lang => <button key={lang} type="button" lang={lang}
      aria-label={t(`shell.language${lang}`)} aria-pressed={i18n.resolvedLanguage === lang}
      onClick={() => { void i18n.changeLanguage(lang); navigate(switchLocalizedPath(location.pathname, lang) + location.search + location.hash, { state: { preserveScroll: true } }) }}>
      {t(`shell.short${lang}`)}
    </button>)}
  </div>
}
